import { useQuery } from '@apollo/client';
import { Box, IconButton } from '@mui/material';
import { graphql } from 'gql';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { DebouncedFirebaseTextField } from '../../DebouncedFirebaseTextField';
import DeleteIcon from '../../Icons/DeleteIcon';
import type { CompData } from '../../RecordingSessionDataGrid/types';
import { sortTakeGroupsByOrdinal } from '../../RecordingSessionDataGrid/util';
import { removeComp } from '../../RecordingSessionEditor/redux/compThunks';
import {
    selectCompById,
    selectTakeGroupsForLine,
} from '../../RecordingSessionEditor/redux/selectors';
import {
    getColorMap,
} from '../../RecordingSessionEditor/util';
import CircleComp from './CircleComp';
import CompText from '../../Comps/CompText';

const GetLineText = graphql(`
    query GetLineText_Comps($lineWhere: LineWhere) {
        lines(where: $lineWhere) {
            id
            lineNo
            text
        }
    }
`)

const GetAudioText = graphql(`
    query GetAudioText_Comps($audioWhere: AudioWhere) {
        audio(where: $audioWhere) {
            id
            tag
            text
        }
    }
`)

type Props = {
    sessionId: string
    episodeId: string
    lineId: string
    compId?: string
}

export default function Comp({ sessionId, episodeId, lineId, compId }: Props) {
    const dispatch = useAppDispatch();

    const takeGroups = useAppSelector((state) => selectTakeGroupsForLine(state, lineId));
    // const takes = useAppSelector(selectTakes);

    const [currentCompId, setCurrentCompId] = useState<string>();
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (compId) setCurrentCompId(compId);
    }, [compId]);

    const comp = useAppSelector((state) => selectCompById(state, currentCompId ?? ''));

    const { data: lineData, loading: loadingLineData } = useQuery(GetLineText, {
        variables: {
            lineWhere: {
                id: lineId.replace('LINE-', ''),
            },
        },
        skip: !lineId || lineId.includes('AUDIO'),
    })

    const { data: audioData, loading: loadingAudioData } = useQuery(GetAudioText, {
        variables: {
            audioWhere: {
                id: lineId.replace('AUDIO-', ''),
            },
        },
        skip: !lineId || !lineId.includes('AUDIO'),
    });

    // const handleClick = (takeId: string) => {
    //     const existingComp = comp?.takes.find(t => t.takeId === takeId);
    //
    //     if (currentCompId && existingComp) {
    //         setLoading(true);
    //
    //         if (comp?.takes.length === 1) {
    //             // no more takes in this comp besides the one we're about to delete, delete the whole comp
    //             dispatch(removeComp({ sessionId, episodeId, compId: currentCompId }))
    //                 .unwrap()
    //                 .then(() => {
    //                     setCurrentCompId(undefined);
    //                     setLoading(false);
    //                 });
    //         } else {
    //             dispatch(removeCompTake({ sessionId, episodeId, takeId, compId: currentCompId }))
    //                 .unwrap()
    //                 .then(() => setLoading(false));
    //         }
    //     }
    //
    //     const selected = window.getSelection()
    //     const selectedText = selected?.toString();
    //
    //     if (!selected || !selectedText) return;
    //     if (!lineData && !audioData) return;
    //     if (!!lineData?.lines[0]?.text && !!audioData?.audio[0]?.text) return;
    //
    //     // HTML selection is not reliable, so we need to check if the selected text is actually in the line
    //     // The line is rendered with extra whitespace removed, so we need to do the same to the selected text
    //     const formattedText = formatCompText((lineData?.lines[0]?.text ?? audioData?.audio[0]?.text)!); // We check to make sure both aren't null/undefined above
    //     const formattedSelected = formatCompText(selectedText);
    //     if (!formattedText.includes(formattedSelected) && !existingComp) return;
    //
    //     // Because the compText is rendered with a different background, the selection might be a substring of the compText
    //     const prevSibling = selected.anchorNode?.previousSibling;
    //     // @ts-ignore
    //     const lastPos = parseInt(prevSibling?.dataset?.endpos ?? '0');
    //
    //     const subString = {
    //         begin: Math.min(selected.anchorOffset, selected.focusOffset) + lastPos,
    //         end: Math.max( selected.anchorOffset, selected.focusOffset) + lastPos,
    //     }
    //
    //     setLoading(true);
    //     if (!currentCompId) {
    //         dispatch(addComp({ sessionId, episodeId, lineId: lineId, takeId, subString }))
    //             .unwrap()
    //             .then((id) => {
    //                 setCurrentCompId(id);
    //                 setLoading(false);
    //             });
    //     }  else {
    //         dispatch(addCompTake({ sessionId, episodeId, compId: currentCompId, takeId, subString }))
    //             .unwrap()
    //             .then(() => setLoading(false));
    //     }
    // }

    const handleDeleteComp = () => {
        if (!currentCompId) return;

        // setLoading(true);
        dispatch(removeComp({ sessionId, episodeId, compId: currentCompId }))
            .unwrap()
            .then(() => {
                setCurrentCompId(undefined);
                // setLoading(false);
            });
    }

    const colorMap = getColorMap(comp);

    const data = takeGroups.toSorted(sortTakeGroupsByOrdinal).map(g => ({
        ...g,
        subTake: [], // (g.subTakeIds.map(tId => takes.find(t => t.id === tId)).filter(t => t) as SubTakeData[]).toSorted(sortBySubTake),
    }));

    return (
        <>
            <Box sx={{ m: 1 }}>
                <CompText
                    lineNo={lineData?.lines[0]?.lineNo ?? audioData?.audio[0]?.tag ?? ''}
                    text={lineData?.lines[0]?.text ?? audioData?.audio[0]?.text ?? ''}
                    loading={loadingLineData || loadingAudioData}
                    comp={comp}
                    colorMap={colorMap}
                />
            </Box>
            {data.map((group) => (
                <Box key={group.id} sx={{ m: 1 }}>
                    Take {group.take}:
                    {/*{group.subTake.map((take) => (*/}
                    {/*    <TakeChip*/}
                    {/*        key={take.id!}*/}
                    {/*        data={take}*/}
                    {/*        loading={loading}*/}
                    {/*        onClick={handleClick}*/}
                    {/*        color={colorMap? colorMap[take.id!] : undefined}*/}
                    {/*    />*/}
                    {/*))}*/}
                </Box>
            ))}
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
            }}>
                {currentCompId && <CircleComp sessionId={sessionId} episodeId={episodeId} compId={currentCompId} />}
                {comp && <DebouncedFirebaseTextField<CompData> objRef={comp.ref!} tooltip='Note' valKey='note' obj={comp} /> }
                {comp && (
                    <IconButton
                        aria-label='delete'
                        onClick={handleDeleteComp}
                        size='small'
                    >
                        <DeleteIcon />
                    </IconButton>
                )}
            </Box>
        </>
    )
}